<template>
  <div>
    <v-layout wrap v-if="dossier.profile">
      <v-flex xs12 mb-12>
        <v-banner class="banner-without-padding" style="z-index:3" sticky color="primary" single-line>
          <v-layout wrap pt-3 style="position: fixed; z-index: 3; width: 50%; background-color:white; height: 50px">
            <v-flex xs6 pl-3>
              <v-btn @click="updateProfileAndCreateDossier({ isOnlyToUpdateProfile: false })" small class="secondary white--text">{{ $t('a') }}</v-btn>
            </v-flex>
            <v-flex xs6 text-end pr-3 pt-1>
              <small class="primary--text">
                <div v-if="(fieldPath && !recentlyWentBackToMainForm) && !forceShowSavedChangesCloudCheckIcon">
                  <v-icon small class="mr-2 primary--text" style="margin-bottom: 1px">mdi-pause</v-icon>
                  <span>{{ $t('b') }}</span>
                </div>
                <div v-else-if="(dossierHasUnsavedChanges || recentlyWentBackToMainForm) && !forceShowSavedChangesCloudCheckIcon">
                  <v-icon small class="mr-2 primary--text" style="margin-bottom: 1px">mdi-autorenew</v-icon>
                  <span>{{ $t('c') }}</span>
                </div>
                <div v-else>
                  <v-icon small class="mr-2 primary--text" style="margin-bottom: 1px">mdi-cloud-check</v-icon>
                  <span>{{ $t('d') }}</span>
                </div>
              </small>
            </v-flex>
          </v-layout>
        </v-banner>
      </v-flex>
      <v-flex xs12>
        <small>
          <v-layout wrap v-if="fieldPath" mb-12>
            <v-flex xs12>
              <edit-field
                :dossier="dossier"
                :fieldPath="fieldPath" 
                :isOcrResultsLoaded="isOcrResultsLoaded"
                :isConsultant="isConsultant"
                :isFromToken="isFromToken"
                :isUsingSelectEntireExperience="isUsingSelectEntireExperience"
                :isUsingSelectEntireEducationOrCertification="isUsingSelectEntireEducationOrCertification"
                @passIsUsingSelectEntireExperience="passIsUsingSelectEntireExperience"
                @passIsUsingSelectEntireEducationOrCertification="passIsUsingSelectEntireEducationOrCertification"
                @setFieldPath="setFieldPath"
                @goBackToMainForm="goBackToMainForm"
                @updateProfileAndCreateDossier="updateProfileAndCreateDossier"
                @showIsSavingIconAFewSeconds="showIsSavingIconAFewSeconds"
              />
            </v-flex>
          </v-layout>
          <v-layout wrap v-else mb-12>
            <v-flex xs12 style="margin-top: 1px" id="view-profile-form">
              <template-chooser :dossier="dossier" :isFromToken="isFromToken" :isConsultant="isConsultant" />
              <labels-chooser :dossier="dossier" v-if="!isConsultant" @updateProfileAndCreateDossier="updateProfileAndCreateDossier"/>
              <view-basics :dossier="dossier" @setFieldPath="setFieldPath" id="view-basics"/>
              <view-technical-skills :dossier="dossier" @setFieldPath="setFieldPath" id="view-technicalSkills"/>
              <view-functional-skills :dossier="dossier" @setFieldPath="setFieldPath" id="view-functionalSkills"/>
              <view-languages :dossier="dossier" @setFieldPath="setFieldPath" id="view-languages"/>
              <view-educations :dossier="dossier" @setFieldPath="setFieldPath" id="view-educations"/>
              <view-certifications :dossier="dossier" @setFieldPath="setFieldPath" id="view-certifications"/>
              <view-experiences :dossier="dossier" :isFromToken="isFromToken" :isConsultant="isConsultant" :cvPdfUrl="cvPdfUrl" :cvPagesNb="cvPagesNb" @setFieldPath="setFieldPath" id="view-experiences"/>
            </v-flex>
          </v-layout>
        </small>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import lodash from 'lodash';
import { mapGetters } from "vuex";

import TemplateChooser from '@/components/profile/TemplateChooser.vue'
import LabelsChooser from '@/components/profile/LabelsChooser.vue'
import ViewBasics from '@/components/profile/ViewBasics.vue'
import ViewLanguages from '@/components/profile/ViewLanguages.vue'
import ViewTechnicalSkills from '@/components/profile/ViewTechnicalSkills.vue'
import ViewFunctionalSkills from '@/components/profile/ViewFunctionalSkills.vue'
import ViewEducations from '@/components/profile/ViewEducations.vue'
import ViewCertifications from '@/components/profile/ViewCertifications.vue'
import ViewExperiences from '@/components/profile/ViewExperiences.vue'
import EditField from '@/components/profile/EditField.vue';

export default {
  components: {
    TemplateChooser,
    LabelsChooser,
    ViewBasics,
    ViewLanguages,
    ViewTechnicalSkills,
    ViewFunctionalSkills,
    ViewEducations,
    ViewCertifications,
    ViewExperiences,
    EditField,
  },
  props: {
    dossier: Object,
    dossierHasUnsavedChanges: Boolean,
    isOcrResultsLoaded: Boolean,
    isConsultant: Boolean,
    isFromToken: Boolean,
    isUsingSelectEntireExperience: Boolean,
    isUsingSelectEntireEducationOrCertification: Boolean,
    cvPdfUrl: String,
    cvPagesNb: Number
  },
  data: () => ({
    fieldPath: null,
    savedScrollEltId: null,
    recentlyWentBackToMainForm: false,
    forceShowSavedChangesCloudCheckIcon: false
  }),
  mounted () {
    
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods: {
    goBackToMainForm(data) {
      const previousFieldPath = JSON.parse(JSON.stringify(this.fieldPath))
      this.fieldPath = null

      setTimeout(() => {
        //// Scrolling 
        // Prepare the scrolling
        let elementToScrollTo;
        if (data.idOfElementToScrollTo) elementToScrollTo = document.getElementById(data.idOfElementToScrollTo)
        else if (this.savedScrollEltId && document.getElementById(this.savedScrollEltId)) elementToScrollTo = document.getElementById(this.savedScrollEltId)
        else if (previousFieldPath) elementToScrollTo = document.getElementById(`view-${previousFieldPath[0]}`);
        // Make the scrolling
        if (elementToScrollTo) {
          const scrollHeight = elementToScrollTo.offsetTop - (data.mousePositionFromTop || 0)
          document.getElementById('profile-sections-container').scrollTop = scrollHeight + (data.additionalPixels || 0)
        }

        //// Blinking
        if (!data.noBlinking) {
          // Prepare data for blinking
          let elementToBlink;
          if (data.idOfElementToBlink) elementToBlink = document.getElementById(data.idOfElementToBlink)
          else if (elementToScrollTo) elementToBlink = elementToScrollTo
          // Make the blinking
          if (elementToBlink) this.makeElementBlink(elementToBlink, data.blinkColor || 'rgba(0, 200, 83, 0.3)')
        }

      }, 1)

      this.showIsSavingIconAFewSeconds()
    },
    showIsSavingIconAFewSeconds() {
      // Start now to show icon "isSaving".
      this.recentlyWentBackToMainForm = true
      setTimeout(() => {
        if (this.recentlyWentBackToMainForm) {
          this.forceShowSavedChangesCloudCheckIcon = true
          setTimeout(() => {
            this.forceShowSavedChangesCloudCheckIcon = false
          }, 1000)
        }
        this.recentlyWentBackToMainForm = false
      }, 2000)
    },
    makeElementBlink(elementToBlink, blinkColor) {
      // Make the last item edited flash in green for a small time
      const originalBackgroundColor = elementToBlink.style.backgroundColor
      elementToBlink.style.backgroundColor = blinkColor === 'red' ? '#e81a1a36' : blinkColor
      setTimeout(() => {
        elementToBlink.style.backgroundColor = originalBackgroundColor
      }, 1000)
    },
    setFieldPath(data) {
      if (data.savedScrollEltId) this.savedScrollEltId = data.savedScrollEltId
      this.fieldPath = data.fieldPath
    },
    setFieldValue(data) {
      lodash.set(this.dossier.profile, data.fieldPath, data.value)
    },
    updateProfileAndCreateDossier(data) {
      this.$emit('updateProfileAndCreateDossier', data)
    },
    passIsUsingSelectEntireExperience(data) {
      this.$emit('passIsUsingSelectEntireExperience', data)
    },
    passIsUsingSelectEntireEducationOrCertification(data) {
      this.$emit('passIsUsingSelectEntireEducationOrCertification', data)
    },
  },
  watch: {
    fieldPath: {
      handler() {
        this.$emit('passEditedFieldPath', { editedFieldPath: this.fieldPath })
        this.$emit('warmUpPythonCloudFunctions')
      },
      deep: true
    },
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Créer le dossier",
    "b": "Sauvegarde automatique en pause.",
    "c": "Sauvegarde en cours...",
    "d": "Sauvegardé."
  },
  "en": {
    "a": "Create CV",
    "b": "Auto-save is paused.",
    "c": "Saving...",
    "d": "Saved."
  }
}
</i18n>
